import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brand, ctaLabels, heroBadges, heroImage } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-gradient-to-b from-cream via-ivory to-parchment pb-14 pt-10 md:pb-24 md:pt-16" data-id="element-101" data-mp="4lqjixa15f41">
      <div className="mx-auto w-full max-w-5xl px-5 text-center md:px-8" data-id="element-102" data-mp="1297f6cerrfdj">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="text-xs font-bold uppercase tracking-[0.2em] text-wine" data-id="element-103" data-mp="1274mtlq59a5n">
          {brand.eyebrow}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.04,
        ease
      }} className="mx-auto mt-4 max-w-4xl font-serif text-[2.35rem] font-semibold leading-[1.1] text-ink sm:text-5xl md:text-6xl" data-id="element-104" data-mp="nbyir4alzley">
          {brand.headline}{' '}
          <span className="italic text-wine" data-id="element-105" data-mp="3o7bzrwu0yng3">{brand.headlineAccent}</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease
      }} className="mx-auto mt-5 max-w-2xl text-lg font-medium leading-relaxed text-ink md:text-2xl" data-id="element-106" data-mp="39albailw2w59">
          {brand.subtitle}
        </motion.p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease
      }} src={heroImage} alt={brand.mockupCaption} className="mx-auto mt-8 w-full max-w-sm md:mt-10 md:max-w-xl" width={1240} height={1240} data-id="element-107" data-mp="358zr0c70zfl1" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease
      }} className="mx-auto mt-8 max-w-2xl md:mt-10" data-id="element-108" data-mp="2hlja05p7n79e">
          <p className="text-base leading-relaxed text-muted md:text-lg" data-id="element-109" data-mp="nat6xa8uyik6">{brand.supporting}</p>

          <p className="mt-5 font-serif text-lg font-semibold text-wine md:text-xl" data-id="element-110" data-mp="iboyiltrcouw">
            {brand.descriptor}
          </p>

          <ul className="mx-auto mt-5 grid max-w-md grid-cols-2 gap-x-4 gap-y-2 text-left text-sm font-semibold text-muted sm:flex sm:max-w-none sm:flex-wrap sm:justify-center sm:gap-x-6" data-id="element-111" data-mp="degdmdh866py">
            {heroBadges.map(badge => <li key={badge} className="inline-flex items-center gap-1.5" data-id="element-112" data-mp="15zq69sj44199">
                <CheckIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-113" data-mp="11151rgwtuvf0" />
                {badge}
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-114" data-mp="3ltgo5tkf8wpx">
            <CtaButton size="xl" className="w-full max-w-xl" data-id="element-115" data-mp="3lui9qrz2d1lw">
              {ctaLabels.primary}
            </CtaButton>
          </div>

          <p className="mt-4 text-sm font-medium text-muted" data-id="element-116" data-mp="3htpwzoqzgekv">
            Pago único · Acceso inmediato · Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}